import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as url from '@boutique/url'

import { brandGroups, brandsStartingWithNumber } from './data'
import { Nav } from './Nav'

export function List(): React.ReactElement {
  return (
    <Wrapper>
      <Container>
        <plume.styles.heading.XL>Liste des marques engagées</plume.styles.heading.XL>

        <Nav />
        <div>
          <Anchor id="sharp" />
          <plume.styles.heading.L>#</plume.styles.heading.L>
          <BrandList>
            {brandsStartingWithNumber.map((brand) => (
              <li key={brand.name}>
                <BrandLink
                  href={
                    url.products({
                      query: { facetFilters: { brands: [brand.slug] } },
                    }).path
                  }
                  target="_blank"
                >
                  <plume.styles.copy.S>{brand.name}</plume.styles.copy.S>
                </BrandLink>
              </li>
            ))}
          </BrandList>

          {brandGroups.map((brandGroup, index) => (
            <>
              <Anchor id={brandGroup.key} />
              <plume.styles.heading.L>{brandGroup.key}</plume.styles.heading.L>
              <BrandList key={index}>
                {brandGroup.value.map((brand) => (
                  <li key={brand.name}>
                    <BrandLink
                      href={
                        url.products({
                          query: { facetFilters: { brands: [brand.slug] } },
                        }).path
                      }
                      target="_blank"
                    >
                      <plume.styles.copy.S>{brand.name}</plume.styles.copy.S>
                    </BrandLink>
                  </li>
                ))}
              </BrandList>
            </>
          ))}
        </div>
      </Container>
    </Wrapper>
  )
}

const Anchor = styled.div`
  position: relative;
  top: -50px;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    top: calc(-${plume.SIZES.HEADER_SUB_NAV_HEIGHT} - 50px);
  }
`

const BrandLink = styled(plume.Link)`
  display: flex;
  width: fit-content;
  max-width: 100%;

  ${plume.styles.copy.S} {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

const BrandList = styled.ul`
  display: grid;
  margin-bottom: 32px;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 10px;

  li {
    overflow: hidden;
  }

  @media screen and ${plume.BREAKPOINTS.MOBILE_L} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const Wrapper = styled.section`
  background-color: ${plume.COLORS.BACKGROUND_SECONDARY};
  flex-grow: 1;
  min-width: 100%;
`

const Container = styled.div`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  width: 100%;
  max-width: 806px;
  border-radius: 8px;
  padding: 40px 16px 20px;

  ${plume.styles.heading.XL}, ${plume.styles.heading.L} {
    margin-bottom: 32px;
  }

  @media screen and ${plume.BREAKPOINTS.MOBILE_M} {
    padding: 80px 32px 20px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin: 88px auto;
  }
`
